import styled from "@emotion/styled";
import { TextField } from "@mui/material";

export const TextFieldBO = styled(TextField)(() => ({
  marginTop: 20,
}));
